import { createSlice, combineReducers } from "@reduxjs/toolkit";
import { reducer as oidcReducer } from "redux-oidc";
const initialState = {
    logout: false
};
const slice = createSlice({
    initialState,
    name: "authCommonReducers",
    reducers: {
        setLogout: (state) => {
            state.logout = true;
        }
    }
});
export const authReducers = combineReducers({
    common: slice.reducer,
    oidc: oidcReducer
});
export const { setLogout } = slice.actions;
